import {
    Checkbox, FormControl,
    FormControlLabel,
    RadioGroup,
    Radio,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow
} from "@mui/material";
import React, {useState} from "react";
import {makeStyles, withStyles} from "@mui/styles";
import CheckboxSubcomponent from "../exercisesubcomponents/CheckboxSubcomponent";
import CheckboxTableSubcomponent from "../exercisesubcomponents/CheckboxTableSubcomponent";
import ActionsComponent from "../components/ActionsComponent";
import globalVars from "../utils/globalVars";

const useStylesNormal = makeStyles({
        myonecheckbox: {
            backgroundColor: 'transparent'
        }
    }
);

const useStylesFeedback = makeStyles({
        myonecheckbox: {
            backgroundColor: ok => ok ? globalVars.feedbackMode.backgroundColor.ok : globalVars.feedbackMode.backgroundColor.notOk,
            // borderWidth: "1px",
            // borderStyle: "solid",
            // borderColor: ok => ok ? '#3ff' : '#f3f',
        }
    }
);


export default function OneCheckboxComponent(props) {
    const [subtype, setSubtype] = useState(props.exercise?.subtype)
    const [columnLabelsWidth, setColumnLabelsWidth] = useState(
        props.exercise.subtype == 'table' ?
            Math.max(props.exercise.column_labels.true.length + props.exercise.column_labels.false.length + 0, 12)
            : 0
    )
    const [expectedAnswer, setExpectedAnswer] =
        useState(props.exercise.answers.find(
            function (e) {
                return e.v
            }).t)
    const [currentAnswer, setCurrentAnswer] = useState(undefined);

    // ### multiplechoice ###
    // OBLIGATORY_KEYS = ['id', 'meta', 'source', 'type']
    // STD_KEYS = ['hint', 'sentence', 'subtitle', 'title']
    //
    // answers.t
    // answers.v
    // column_labels.false
    // column_labels.true
    // header
    // numberanswers
    // sentencenr
    const mode = 'mode_feedback'
    const classesModeNormal = useStylesNormal();
    const classesModeFeeback = useStylesFeedback(expectedAnswer == currentAnswer);
    const classes = {
        'mode_normal': classesModeNormal,
        'mode_feedback': classesModeFeeback,
    }

    function handleChange(e) {
        setCurrentAnswer(e.target.value);
    }

    const [showSolution, setShowSolution] = useState(false);

    function handleShowSolution() {
        setShowSolution(!showSolution)
    }

    const [showFeedback, setShowFeedback] = useState(false);

    function handleShowFeedback() {
        setShowFeedback(!showFeedback)
    }

    return (
        <div key={props.index}>
            {/*<span style={{backgroundColor: 'magenta'}}>*/}
            {/*    {subtype} {columnLabelsWidth.toString() + 'em' + " [" + expectedAnswer + "]==[" + currentAnswer + "]"}*/}
            {/*</span><br/>*/}
            <FormControl sx={{border: "1px solid #ccc"}}>
                <RadioGroup
                    onChange={handleChange}
                    // className={classes[props.feedbackMode].myonecheckbox}
                    className={classes[showFeedback ? "mode_feedback" : "mode_normal"].myonecheckbox}
                >
                    {
                        props.exercise.answers.map(
                            (r, ri) => {
                                return (
                                    <FormControlLabel
                                        key={ri}
                                        value={r.t}
                                        style={{
                                            paddingLeft: '1em',
                                            marginRight: '0em',
                                            marginLeft: '0em',
                                            paddingRight: '1em',
                                            backgroundColor: (r.v && showSolution) ? globalVars.solutionMode.on : globalVars.solutionMode.off
                                        }}
                                        control={<Radio size='small' style={{
                                            // backgroundColor: r.v ? globalVars.solutionMode.on : "transparent",
                                            xbackgroundColor: "transparent",
                                        }}/>}
                                        label={r.t}
                                    />
                                )
                            }
                        )
                    }
                </RadioGroup>
            </FormControl>
            <ActionsComponent
                onToggleShowSolution={handleShowSolution}
                onToggleShowFeedback={handleShowFeedback}
                {...props}
            />

        </div>
    );
}

/*
export function ExerciseMultipleChoiceOnecheckboxComponent(props) {
    return (
        <div key={props.index}>
            {/!*obligatory fields*!/}
            <p>answers = {JSON.stringify(props.exercise.answers, null, 2)}</p>
            {/!*optional fields*!/}
            {props.exercise.sentence && <p>sentence = {props.exercise.sentence}</p>}
            {props.exercise.title && <p>title = {props.exercise.title}</p>}
        </div>
    );
}

export function ExerciseMultipleChoiceTableComponent(props) {
    return (
        <div key={props.index}>
            {/!*obligatory fields*!/}
            <p>answers = {JSON.stringify(props.exercise.answers, null, 2)}</p>
            <p>column_labels = {JSON.stringify(props.exercise.column_labels, null, 2)}</p>
            <p>header = {props.exercise.header}</p>
            <p>title = {props.exercise.title}</p>
            {/!*optional fields*!/}
            {props.exercise.sentence && <p>sentence = {props.exercise.sentence}</p>}
            {props.exercise.numberanswers && <p>numberanswers = {props.exercise.numberanswers}</p>}
        </div>
    );
}

*/
